// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price_currency__2tm2O {\n  font-size: 19px;\n}", "",{"version":3,"sources":["webpack://src/components/Price/price.module.scss"],"names":[],"mappings":"AACA;EACE,eAAA;AAAF","sourcesContent":["@import \"../../assets/scss/variables\";\n.currency {\n  font-size: 19px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currency": "price_currency__2tm2O"
};
export default ___CSS_LOADER_EXPORT___;
